import styled from "styled-components";
import Login from "./pages/Login";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import CommissionPackagePage from "./pages/CommissionPackagePage";
import Dashboard from "./pages/Dashboard";
import PackPackage from "./pages/PackPackage";
import ShipPackagePage from "./pages/ShipPackagePage";
import ReceivePackage from "./pages/ReceivePackage";
import UnpackPackage from "./pages/UnpackPackage";
import ModalDrop from "./components/modals/ModalDrop";
import { useContext } from "react";
import { AuthContext } from "./context/AuthProvider";
import LogOutModalMobile from "./components/modals/LogOutModalMobile";
import Loading from "./components/Loading";
import DecommissionPackagePage from "./pages/DecommissionPackagePage";
import DispensePackage from "./pages/DispensePackage";
import PersistLogin from "./hooks/PersistLogin";
import ProductGuide from "./pages/Guide";
import VerifyPackage from "./pages/VerifyPackage";
import PackageList from "./pages/PackageList";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

const Contaiainer = styled.div`
  width: min(97%, 480px);
  margin: auto;
  position: relative;
  min-height: 60vh;
`;

function App() {
  const { closeLogoutFormMobile, setCloseLogoutFormMobile, loading } =
    useContext(AuthContext);
  return (
		<>
			{closeLogoutFormMobile && (
				<ModalDrop onclick={() => setCloseLogoutFormMobile(false)}>
					<LogOutModalMobile
						clickModal={(e) => e.stopPropagation()}
					/>
				</ModalDrop>
			)}
			{loading && (
				<ModalDrop>
					<Loading />
				</ModalDrop>
			)}
			<Contaiainer>
				<Routes>
					<Route index element={<Login />} />
					<Route
						path={"/forgot-password"}
						element={<ForgotPassword />}
					/>
					<Route
						path={"/reset-password"}
						element={<ResetPassword />}
					/>
					<Route element={<PersistLogin />}>
						<Route path={"/pages"} element={<Home />}>
							<Route index element={<Dashboard />} />
							<Route
								path={"/pages/commissioning"}
								element={<CommissionPackagePage />}
							/>
							<Route
								path={"/pages/packing"}
								element={<PackPackage />}
							/>
							<Route
								path={"/pages/shipping"}
								element={<ShipPackagePage />}
							/>
							<Route
								path={"/pages/receiving"}
								element={<ReceivePackage />}
							/>
							<Route
								path={"/pages/unpacking"}
								element={<UnpackPackage />}
							/>
							<Route
								path={"/pages/dispense"}
								element={<DispensePackage />}
							/>
							<Route
								path={"/pages/decommissioning"}
								element={<DecommissionPackagePage />}
							/>
							<Route
								path={"/pages/guide"}
								element={<ProductGuide />}
							/>
							<Route
								path={"/pages/packages"}
								element={<PackageList />}
							/>
							<Route
								path={"/pages/verify-pack"}
								element={<VerifyPackage />}
							/>
						</Route>
					</Route>
				</Routes>
			</Contaiainer>
		</>
  );
}

export default App;
